import { render, staticRenderFns } from "./ReportsInactiveClients.vue?vue&type=template&id=2f2b522a"
import script from "./ReportsInactiveClients.vue?vue&type=script&lang=js"
export * from "./ReportsInactiveClients.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports